import { render, staticRenderFns } from "./campus.vue?vue&type=template&id=a2a7f4fc&scoped=true"
import script from "./campus.vue?vue&type=script&lang=js"
export * from "./campus.vue?vue&type=script&lang=js"
import style0 from "./campus.vue?vue&type=style&index=0&id=a2a7f4fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a7f4fc",
  null
  
)

export default component.exports